import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as appActionCreator from "../redux/actions/app";
import * as studentActionCreator from "../redux/actions/student";
import $ from "jquery";
import StudentSearch from "../pages/StudentSearch";
import MainApp from "./MainApp";
import { NavigationComponent } from "../types";
import AccessLogs from "../pages/AccessLogs";
import AboutStudent from "../pages/AboutStudent";
import Advisors from "../pages/Advisors";
import EmergencyContacts from "../pages/EmergencyContacts";
import Academic from "../pages/Academic";
import StudentLife from "../pages/StudentLife";
import StudentSupport from "../pages/StudentSupport";
import PrivacySettings from "../pages/PrivacySettings";
import StudentController from "../api/StudentController";
import Loader from "react-loader";
import NoAccess from "../pages/NoAccess";

interface ContentProps
{
    name: string;
    role: string;
    page: string;
    actions: any;
}

interface ContentState
{
    page: string;
    isLoading: boolean;
    isAuth: boolean;
}

class Content extends React.Component<ContentProps, ContentState>
{
    studentController: StudentController;

    constructor(props: ContentProps)
    {
        super(props);

        this.state = {
            isLoading: true,
            page: "search",
            isAuth: false
        };

        this.studentController = new StudentController();
    }

    appSetup: NavigationComponent[] =
        [
            {
                title: "Access Log",
                id: "accessLog",
                param: "",
                role: ["student", "dev"],
                Component: <AccessLogs />
            },
            {
                title: "About Student",
                id: "about",
                param: "",
                role: ["student", "studentSupportDean", "academicAdvisor", "dev"],
                Component: <AboutStudent />
            },
            {
                title: "Advisors",
                id: "advisors",
                param: "",
                role: ["student", "studentSupportDean", "academicAdvisor", "dev"],
                Component: <Advisors />
            },
            {
                title: "Emergency Contacts",
                id: "emergencyContacts",
                param: "",
                role: ["student", "studentSupportDean", "academicAdvisor", "dev"],
                Component: <EmergencyContacts />
            },
            {
                title: "Academic",
                id: "academic",
                param: "",
                role: ["student", "studentSupportDean", "academicAdvisor", "dev"],
                Component: <Academic />
            },
            {
                title: "Student Life",
                id: "studentLife",
                param: "",
                role: ["student", "studentSupportDean", "academicAdvisor", "dev"],
                Component: <StudentLife />
            },
            {
                title: "Student Support",
                id: "studentSupport",
                param: "",
                role: ["studentSupportDean", "dev"],
                Component: <StudentSupport />
            },
            {
                title: "Privacy Settings",
                id: "privacySettings",
                param: "",
                role: ["student", "dev"],
                Component: <PrivacySettings />
            }
        ];

    async componentDidMount(): Promise<void> 
    {
        const studentController = new StudentController();

        const user = await studentController.initialize();

        if (user)
        {
            if (window.location.hash.split("/")[2])
            {
                const selectedStudent = { kerbId: window.location.hash.split("/")[2], name: "" };
                this.props.studentAction.selectStudent(selectedStudent);
            }

            this.props.actions.changeUser(user.user);
            this.setState({ isAuth: true,isLoading: false });
        }
        else
        {
            console.error('Initialize failed - user object not returned. API call may have failed or authentication check failed.');
            this.setState({
                isAuth: false,
                isLoading: false
            });
        }
    }

    render(): React.ReactNode 
    {
        console.log(`%c` + `this.state.isLoading`.toUpperCase(), "color: green; font-weight: bold;", this.state.isLoading);
        //Doing initial call
        if (this.state.isLoading)
            return (<div>
                <div style={{ position: "fixed", top: "50%", left: "50%", right: "50%" }}>
                    <Loader className={"spinner"} position={"fixed"} radius={15} corners={1} color={"#8d3433"} opacity={0.25} rotate={0} direction={1} speed={1} trail={60} />
                </div>
                <div style={{ position: "absolute", top: "50%", textAlign: "center", width: "100%", marginTop: "-100px", left: 0 }}>
                    <b>Loading Canopy...</b>
                </div>
            </div>);

        //Check Access
        if (!this.state.isAuth)
            return <NoAccess />;

        if (this.props.settings.length > 0)
        {
            if (this.props.role == "academicAdvisor" && this.props.settings.filter(itm => itm.settingId == "psStudentLife")[0].isActive == true && this.props.settings.filter(itm => itm.settingId == "psStudentFinancial")[0].isActive == true)
                this.appSetup = $.grep(this.appSetup, function (e)
                {
                    return e.id != "studentLife";
                });
        }

        if (window.location.hash.split("/")[2])
            return <MainApp
                title={this.props.name}
                appSetup={this.appSetup} />

        return (
            <React.Fragment>
                {
                    (this.props.role == "student")
                        ?
                        <MainApp
                            title={this.props.name}
                            appSetup={this.appSetup} />
                        :
                        (this.props.page == "search")
                            ?
                            <StudentSearch />
                            :
                            <MainApp
                                title={this.props.name}
                                appSetup={this.appSetup} />
                }
            </React.Fragment>);
    }
}

const mapStateToProps = (state: any) => ({
    page: state.app.page,
    settings: state.app.privacySettings,
    role: state.app.user.role
});

const mapDispatchToProps = (dispatch: any) => ({
    actions: bindActionCreators(appActionCreator, dispatch),
    studentAction: bindActionCreators(studentActionCreator, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Content);